import { SimpleGrid } from "@chakra-ui/react";
import { Section } from "components/section";
import React from "react";
import { TextTitle } from "ui/text";
import { integrationsCount } from "../../../constants/integrations";

export function DataActivationSteps() {
  return (
    <Section theme="dark" bg="new.gray.950" themeBgColor="new.gray.950" py="0">
      <SimpleGrid as="ol" columns={{ base: 1, md: 3 }} gap="bigger" justifyItems="center">
        <TextTitle
          as="li"
          theme="dark"
          size="xs"
          chip={{ text: "Step 1", variant: "green" }}
          title="Implement Hightouch’s SDK"
          titleAs="h3"
          description="Add simple tracking code to your website, mobile app, or server-side application to track any events you like."
        />

        <TextTitle
          as="li"
          theme="dark"
          size="xs"
          chip={{ text: "Step 2", variant: "green" }}
          title="Stream data to your destinations"
          titleAs="h3"
          description="Deliver clean, reliable event data to your data warehouse, ESP, or other tools with full flexibility for any schema or use case."
        />

        <TextTitle
          as="li"
          theme="dark"
          size="xs"
          chip={{ text: "Step 3", variant: "green" }}
          title="Activate data across your tools"
          titleAs="h3"
          description={`Put event data to work in the marketing, advertising, analytics, and operational tools you use every day. Hightouch integrates with ${integrationsCount}+ tools.`}
        />
      </SimpleGrid>
    </Section>
  );
}
